// import { folderStyles as style } from "./Folders.style";
import { folderStyles as style } from "../Folders/Folders.style";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";

import { getRecommendedArticles } from "../../../api/MyLibrary/MyFolders.api";
import { GetFolderArticlesData } from "../../../types/GetMyFolders.types";
import { useAppSelector } from "../../../store/hooks";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "../../../components/spinner";
import FolderDetailCard from "../Folders/FolderDetailCard";
import {
  updateMarkedArticleId,
  updateMarkedResult,
} from "../../../store/slice/searchSlice";
import { useDispatch } from "react-redux";
import { Checkbox, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const RecommendedArtcleDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = useAppSelector((state) => state.login.user_id);
  const customeridId = useAppSelector(
    (state) => state.login.informaticscustomer_id
  );
  const dataTypes = useAppSelector((state) => state.searchReducer.dataType);
  const l2Subjects = useAppSelector((state) => state.searchReducer.subjectType);
  const [articles, setArticles] = useState<GetFolderArticlesData>();
  const markedArticlesid = useAppSelector(
    (state) => state.searchReducer.markedArticleId
  );
  const [markedData, setMarkdeData] = useState<string[]>(markedArticlesid);
  const [markResult, setMarkResult] = useState(false);
  const markedResult = useAppSelector(
    (state) => state.searchReducer.markedResult
  );

  useQuery({
    queryKey: [
      "GetRecommendedArticles",
      userId,
      customeridId,
      l2Subjects,
      dataTypes,
    ],
    queryFn: () =>
      getRecommendedArticles(userId, customeridId, l2Subjects, dataTypes),
    select: ({ data }): GetFolderArticlesData => data?.data,
    onSuccess(data) {
      setArticles(data);
    },
  });

  useEffect(() => {
    setMarkResult(markedData?.length === articles?.docs?.length);
  }, [articles?.docs?.length, markedData?.length]); //Remove articles?.docs?.length

  const selectAllArticles = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    const dataArray = articles?.docs;

    if (!Array.isArray(dataArray)) return;

    if (target?.checked) {
      let filteredMarkedIds = [];
      let filteredMarkedData = [];
      let articlesIds = dataArray?.map((obj) => obj?.article_id);

      for (let id of articlesIds) {
        if (!markedArticlesid.includes(id)) filteredMarkedIds.push(id);
      }

      for (let obj of dataArray) {
        if (filteredMarkedIds.includes(obj?.article_id))
          filteredMarkedData.push(obj);
      }

      dispatch(updateMarkedResult([...markedResult, ...filteredMarkedData]));
      dispatch(
        updateMarkedArticleId([...markedArticlesid, ...filteredMarkedIds])
      );
      setMarkdeData(articlesIds);
    } else {
      setMarkdeData([]);
      // curr res ids
      let articlesIds = dataArray?.map((obj) => obj?.article_id);

      // check the current res id in marked articls ids and remove all
      let filteredMarkedIds = [];
      let filteredMarkedData = [];

      for (let id of markedArticlesid) {
        if (!articlesIds.includes(id)) filteredMarkedIds.push(id);
      }

      dispatch(updateMarkedArticleId(filteredMarkedIds));

      // keep the data in mark result that matches  "filteredMarkedIds"
      for (let obj of markedResult) {
        if (filteredMarkedIds.includes(obj?.article_id))
          filteredMarkedData.push(obj);
      }

      dispatch(updateMarkedResult(filteredMarkedData));
    }
  };

  const getMarkedResult = (data: any, id: string) => {
    // Handle id
    if (markedArticlesid.includes(id)) {
      let filterIds = markedArticlesid.filter((data) => data !== id);
      let filterData = markedResult.filter(
        (data: any) => data?.article_id !== id
      );
      dispatch(updateMarkedResult(filterData));
      dispatch(updateMarkedArticleId(filterIds));
      setMarkdeData((prev) => prev.filter((obj) => obj !== id));
    } else if (markedArticlesid?.length) {
      let articlesIds = [...markedArticlesid, id];
      let markedResultData = [...markedResult, data];
      dispatch(updateMarkedResult(markedResultData));
      dispatch(updateMarkedArticleId(articlesIds));
      setMarkdeData((prev) => [...prev, id]);
    } else {
      dispatch(updateMarkedArticleId([id]));
      dispatch(updateMarkedResult([data]));
      setMarkdeData([id]);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Checkbox
          sx={{ ml: "5px" }}
          onChange={selectAllArticles}
          checked={markResult}
          inputProps={{ "aria-label": "controlled" }}
        />
        <Typography
          style={{
            alignSelf: "center",
            marginRight: "4%",
            cursor: "pointer",
          }}
          onClick={() => {
            if (!markedData.length) return;
            navigate("/marked-result");
          }}
        >
          {markedData?.length ? `View Marked Results` : "Mark Results"}
          {markedData?.length > 0 ? "(" + markedData?.length + ")" : ""}
        </Typography>
      </Box>
      <Box sx={style.listWrapper}>
        {articles ? (
          Array.isArray(articles.docs) ? (
            articles.docs?.map((article, i) => (
              <FolderDetailCard
                key={i}
                data={article}
                getMarkedResult={getMarkedResult}
                markedArticlesid={markedData}
                articles={articles.docs}
              />
            ))
          ) : (
            <>No Recommonded Articles </>
          )
        ) : (
          <Loader height={"100%"} width={"100%"} />
        )}
      </Box>
    </>
  );
};

export default RecommendedArtcleDetails;
